import React from 'react';
import { Image, Pressable, StyleProp, View, ViewStyle } from 'react-native';
import type { ScenarioNotice } from '../../../helpers/scenarioReview';
import useTranslation from '../../../hooks/translation-hook';
import Label from '../Label';

interface Props {
  notice?: ScenarioNotice;
  onRead?: () => void;
  style?: StyleProp<ViewStyle>;
}

const ScenarioUpdateNotice = ({ notice, onRead, style }: Props) => {
  const t = useTranslation();
  if (!notice?.isActive) return null;
  const bannerStyle: ViewStyle = { minHeight: 24, paddingVertical: 4, paddingHorizontal: 6, borderRadius: 3,
    backgroundColor: '#EF7903', flexDirection: 'row', alignItems: 'flex-start', gap: 6, minWidth: 0 };
  const content = <>
    <Image source={require('../../../../assets/scenario-updated-eyes.png')} accessible={false}
      resizeMode="contain" style={{ width: 17, height: 13, marginTop: 1.5, flexShrink: 0, tintColor: '#000000' }} />
    <Label numberOfLines={0} style={{ color: '#FFFFFF', fontSize: 12, lineHeight: 16, fontWeight: '600', flex: 1, minWidth: 0 }}>
      {t('scenario-update-body')}
    </Label>
  </>;
  return <View testID="scenario-update-notice" style={[{ minWidth: 0, marginBottom: 12 }, style]}>
    {onRead ? <Pressable testID="scenario-update-read" accessibilityRole="button" accessibilityLabel={t('scenario-update-body')}
      onPress={onRead} hitSlop={10} style={bannerStyle}>{content}</Pressable> : <View style={bannerStyle}>{content}</View>}
  </View>;
};

export default ScenarioUpdateNotice;
